import { cn } from '../../Utlils';
import { HelperText, Tooltip } from './Ui';

const InformationTile = ({ rowLabel, rowValue, className, showTooltip }) => {
  const isPrimitive =
    typeof rowValue === 'string' || typeof rowValue === 'number';

  const ValueContent = isPrimitive ? (
    <p className="text-sm font-medium w-[300px] text-right line-clamp-2">
      {rowValue}
    </p>
  ) : (
    <>{rowValue}</>
  );

  return (
    <div className={cn('flex justify-between py-2', className)}>
      <HelperText
        className="text-gray-500 text-sm font-[400] w-[40%]"
        error={false}
      >
        {rowLabel}
      </HelperText>

      {showTooltip ? (
        <Tooltip
          position="bottom"
          content={isPrimitive ? String(rowValue) : ''}
        >
          {ValueContent}
        </Tooltip>
      ) : (
        ValueContent
      )}
    </div>
  );
};

export default InformationTile;
